var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7439 10.3829C46.7439 9.51255 46.3981 8.67785 45.7827 8.06242C45.1673 7.44698 44.3326 7.10124 43.4622 7.10124H36.8989V3.81958H33.6172V7.10124H20.4906V3.81958H17.2089V7.10124H10.6456C9.77526 7.10124 8.94056 7.44698 8.32513 8.06242C7.7097 8.67785 7.36395 9.51255 7.36395 10.3829V43.1995C7.36395 44.0698 7.7097 44.9045 8.32513 45.52C8.94056 46.1354 9.77526 46.4812 10.6456 46.4812H17.2089V43.1995H10.6456V10.3829H17.2089V13.6646H20.4906V10.3829H33.6172V13.6646H36.8989V10.3829H43.4622V20.2279H46.7439V10.3829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2581 25.1504L39.4406 33.2528L48.3847 34.5507L41.8214 40.8581L43.4623 49.7628L35.2581 45.559L27.054 49.7628L28.6948 40.8581L22.1315 34.5507L31.3201 33.2528L35.2581 25.1504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonEvent);
export default __webpack_public_path__ + "static/media/carbon_event.ead3cbdb1e648a99f3c6da8699a688c5.svg";
export { ForwardRef as ReactComponent };